interface ApprovalCenterProps { }
const ApprovalCenter = (props: ApprovalCenterProps) => {
  return (
    <div className="w-100 h-100 d-flex align-items-center justify-content-center text-secondary">
      เลือกงานทางซ้ายเพื่อดูรายละเอียด
    </div>
  );
};

export default ApprovalCenter;
